import ExcelFileUpload from "components/UI/FileUpload/ExcelFileUpload";
import React from "react";
import { UnitFields } from "type/dl_unit/dl_unit.type";
import { formatUnitExcelData } from "./UnitExcelUpload.logic";

type UnitExcelUploadProps = {
  onUnitExcelDataRetrieve: (fields: UnitFields[]) => void;
};

const UnitExcelUpload: React.FC<UnitExcelUploadProps> = ({
  onUnitExcelDataRetrieve,
}: UnitExcelUploadProps) => {
  const excelDataRetrieveHandle = (data: any[]) => {
    const fields: UnitFields[] = formatUnitExcelData(data);

    onUnitExcelDataRetrieve(fields);
  };

  return <ExcelFileUpload onExcelDataRetrieve={excelDataRetrieveHandle} />;
};

export default UnitExcelUpload;
